// extracted by mini-css-extract-plugin
export var closeButton = "_m5-1";
export var closeX = "_m5-3";
export var container = "_m5-0";
export var image = "_m5-2";